<div class="quick-justification">
  <div class="quick-justification__header">
    <span class="quick-justification__icon"><mat-icon>fact_check</mat-icon></span>
    <div>
      <span>{{ (translationPrefix + '.eyebrow') | translate }}</span>
      <h2>{{ (translationPrefix + '.title') | translate }}</h2>
      <p>{{ (translationPrefix + '.description') | translate }}</p>
    </div>
    <button mat-icon-button type="button" (click)="close()" [disabled]="isSaving"
            [attr.aria-label]="'common.close' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="quick-justification__body">
    <div class="absence-context">
      <span class="absence-context__avatar">{{ employeeName.charAt(0) }}</span>
      <div class="absence-context__employee">
        <span>{{ (translationPrefix + '.employee') | translate }}</span>
        <strong>{{ employeeName }}</strong>
        <small>{{ employeeNumber }}</small>
      </div>
      <div class="absence-context__date">
        <mat-icon>{{ isPartialMinutesFlow ? 'schedule' : 'event_busy' }}</mat-icon>
        <span>{{ (translationPrefix + '.eventDate') | translate }}</span>
        <strong>{{ formattedWorkDate }}</strong>
      </div>
    </div>

    @if (isLoading) {
      <div class="quick-justification__loading">
        <span></span>
        {{ (translationPrefix + '.loadingTypes') | translate }}
      </div>
    } @else {
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>{{ (translationPrefix + '.type') | translate }}</mat-label>
        <mat-icon matPrefix>task_alt</mat-icon>
        <mat-select [(ngModel)]="selectedTypeId" required>
          @for (type of justificationTypes; track type.attendanceJustificationTypeId) {
            <mat-option [value]="type.attendanceJustificationTypeId">{{ type.label }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      @if (selectedType; as type) {
        <div class="type-summary">
          <span><mat-icon>{{ isPartialMinutesFlow ? 'timer' : 'calendar_today' }}</mat-icon>{{ (translationPrefix + '.scope') | translate }}</span>
          <span><mat-icon>payments</mat-icon>{{ type.payEffect === 'paid' ? ('attendanceJustificationsCatalog.payEffectOptions.paid' | translate) : ('attendanceJustificationsCatalog.payEffectOptions.unpaid' | translate) }}</span>
          @if (type.requiresApproval) {
            <span><mat-icon>approval</mat-icon>{{ (translationPrefix + '.requiresApproval') | translate }}</span>
          }
        </div>
      }

      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>{{ (translationPrefix + '.comment') | translate }}</mat-label>
        <textarea matInput rows="3" [(ngModel)]="comment"
                  [required]="selectedType?.requireComment === true"
                  [placeholder]="(translationPrefix + '.commentPlaceholder') | translate"></textarea>
      </mat-form-field>

      <div class="attachment-box">
        <div>
          <span class="attachment-box__icon"><mat-icon>attach_file</mat-icon></span>
          <div>
            <strong>
              {{ (translationPrefix + '.attachments') | translate }}
              @if (selectedType?.requireAttachment) {
                <span class="required-badge">{{ (translationPrefix + '.required') | translate }}</span>
              }
            </strong>
            <small>{{ (translationPrefix + '.attachmentsHint') | translate }}</small>
          </div>
        </div>
        <label class="attachment-box__button">
          <mat-icon>add_photo_alternate</mat-icon>
          {{ (translationPrefix + '.selectImages') | translate }}
          <input type="file" accept="image/*" multiple
                 [attr.aria-required]="selectedType?.requireAttachment === true"
                 (change)="onFilesSelected($event)" />
        </label>
      </div>

      @if (selectedFiles.length) {
        <div class="selected-files">
          @for (file of selectedFiles; track file.name + file.size; let index = $index) {
            <div>
              <mat-icon>image</mat-icon>
              <span><strong>{{ file.name }}</strong><small>{{ (file.size / 1024 / 1024) | number:'1.1-1' }} MB</small></span>
              <button mat-icon-button type="button" (click)="removeFile(index)" [disabled]="isSaving">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          }
        </div>
      }
    }
  </div>

  <div class="quick-justification__actions">
    <button mat-stroked-button type="button" (click)="close()" [disabled]="isSaving">
      {{ 'common.cancel' | translate }}
    </button>
    <button mat-flat-button type="button" class="quick-save-button" (click)="save()"
            [disabled]="isLoading || isSaving || !justificationTypes.length">
      @if (isSaving) {
        <span class="button-spinner"></span>
        {{ (translationPrefix + '.saving') | translate }}
      } @else {
        <span class="quick-save-button__content">
          <mat-icon>save</mat-icon>
          {{ (translationPrefix + '.save') | translate }}
        </span>
      }
    </button>
  </div>
</div>
